module.exports = __webpack_public_path__ + "assets/img/sprite.e6dd7232.svg";